import React, { useState } from 'react'
import useDeliveryPickupAxios, { useDeliveryPickupFormData } from '../utils/axios';

function useOrderProcessingApi () {

    const DeliveryPortalAxios = useDeliveryPickupAxios();
    const DeliveryPortalAxios1 = useDeliveryPickupFormData();
    const DeliveryPortalClient = DeliveryPortalAxios;
    DeliveryPortalClient.defaults.timeout = 600000;
    const DeliveryPortalClient1 = DeliveryPortalAxios1;
    DeliveryPortalClient1.defaults.timeout = 600000;

    const [orderTypes, setOrderTypes] = useState([]);

    const CancelOrder = async (payload) => {
        const response = await DeliveryPortalAxios.post("/OrderProcessing/CancelOrder", payload)
        
        return response.data.payload;
    }

    const GetOrderTypes = async () => {
      try{
         const response = await DeliveryPortalAxios.get("/OrderProcessing/GetOrderTypes")

          if(response && response.data.payload) {
            setOrderTypes(response.data.payload)
          }

      } catch (error) {
        console.error(error);
      } 
    }

    const DeleteOrder = async (payload) => {
      const response = await DeliveryPortalAxios.delete("/OrderProcessing/DeleteOrder", {
          headers: {
              'Content-Type': 'application/json'
          },
          data: payload
      });
    
      return response.data;
  }

  return {
    CancelOrder,
    GetOrderTypes,
    orderTypes,
    DeleteOrder
  }


}


export default useOrderProcessingApi;